import Anchor from 'containers/ac-containers/ac-anchor';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
	AppointmentSection,
	ClassesSection,
	ClassRoomSection,
	GlobalOnlineSchoolSection,
	MapCoversSection,
	RatingSection,
	SafeguardSection,
} from './components';
import styles from './styles.scss';

/**
 * 6过落地页
 */
export default function MainHome() {
	const anchor = useHistory().location.hash;
	const { setTrigger, setEvent } = useModalContext();
	const { transData } = useTranslation('home');

	useEffect(() => {
		if (!anchor) {
			window.scrollTo(0, 0);
		}
	}, []);

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-home']}>
				<AppointmentSection
					onClick={() => {
						setTrigger(true);
						setEvent({ eventId: 'ACW_getlesson' });
					}}
				/>
				<ClassesSection />
				<ClassRoomSection />
				<MapCoversSection />
				<RatingSection />
				<GlobalOnlineSchoolSection />
				<SafeguardSection />
				<Anchor className={styles.anchor} anchorText={'appointment'} eventId="PAG_aa338e2331a83a1b">
					<img src={transData.toTop} alt="" loading="lazy" />
				</Anchor>
			</main>
		</div>
	);
}
